/**
 * Keys for env.strings (backend / login payload) + English fallbacks.
 * Merge these into your Canva app env `strings` object for localization.
 */
export const CANVA_TOP_NAV_STRING_KEYS = {
  ariaLabel: 'app-canva-top-nav-aria-label',
  logoAlt: 'app-canva-top-nav-logo-alt',
  studio: 'app-canva-top-nav-studio',
  soundtracker: 'app-canva-top-nav-soundtracker',
  about: 'app-canva-top-nav-about',
  ctaCreateSoundtrack: 'app-canva-top-nav-cta-create-soundtrack',
} as const;

export const CANVA_TOP_NAV_DEFAULTS: Record<string, string> = {
  [CANVA_TOP_NAV_STRING_KEYS.ariaLabel]: 'Main navigation',
  [CANVA_TOP_NAV_STRING_KEYS.logoAlt]: 'Muzaic',
  [CANVA_TOP_NAV_STRING_KEYS.studio]: 'Studio',
  [CANVA_TOP_NAV_STRING_KEYS.soundtracker]: 'Soundtracker',
  [CANVA_TOP_NAV_STRING_KEYS.about]: 'About',
  [CANVA_TOP_NAV_STRING_KEYS.ctaCreateSoundtrack]: 'Create soundtrack',
};
